<mat-nav-list>
    <a mat-list-item (click)="clickSwitchCamera()" style="text-decoration: none;">
        <mat-icon mat-list-icon>flip_camera_android</mat-icon>
        <span mat-line>Changer de camera</span>
    </a>
</mat-nav-list>
